import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { AutofocusDirective } from '@sb/shared/util';
import { TooltipDirective } from '@sb/tooltip';
import { BadgeComponent } from '@sb/ui/badge';
import { ButtonComponent } from '@sb/ui/button';
import { useGridRowPinHold } from '@sb/ui/grid-scroll';
import { IconComponent } from '@sb/ui/icon';
import { InputDirective } from '@sb/ui/input';
import { PopoverDirective, PopoverModule } from '@sb/ui/popover';

@Component({
  selector: 'app-timesheet-row-edit-textarea',
  imports: [
    CommonModule,
    PopoverModule,
    TooltipDirective,
    IconComponent,
    ButtonComponent,
    InputDirective,
    AutofocusDirective,
    BadgeComponent,
    TranslatePipe,
    FormsModule,
  ],
  templateUrl: './timesheet-row-edit-textarea.component.html',
})
export class TimesheetRowEditTextareaComponent implements OnChanges {
  private cdr = inject(ChangeDetectorRef);

  // The popover's content lives in an overlay, so the row's own focus pin does not cover it.
  rowHold = useGridRowPinHold();

  @Input()
  value: string | undefined;
  @Input()
  isSaving = false;
  @Input()
  popoverTitle: string | undefined;

  @Output()
  saved: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild(PopoverDirective, { static: true })
  popoverDirective: PopoverDirective;

  inputValue = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']?.currentValue !== changes['value']?.previousValue) {
      this.resetValue();
    }
  }

  onClose(): void {
    this.popoverDirective.close();
    this.resetValue();
  }

  onSave(): void {
    this.saved.emit(this.inputValue);
    this.popoverDirective.close();
  }

  private resetValue() {
    const value = this.value || '';
    if (this.inputValue !== value) {
      this.inputValue = value;
      this.cdr.detectChanges();
    }
  }
}
